import { APP_CLEAR_CURRENT_USER } from '../actions/app.actions'
import * as Actions from '../actions/objectCampain.actions'

const initialState = []

export default (state = initialState, action) => {
  switch (action.type) {
    case Actions.OBJ_CLEAR:
      return []
    case Actions.LIST_OBJ:
      return [
        ...state.filter((obj) => obj !== action.objcampain.id),
        action.objcampain,
      ]
    case APP_CLEAR_CURRENT_USER:
      return initialState
    default:
      return state
  }
}